<div>
  <p-panel header="Servicing Facility">
    @if (userFacilities?.length) {
      <div class="mb-4">
        <div class="flex items-center">
          <p-checkbox
            inputId="differentFacilityCheck"
            data-test-id="different-facility-checkbox"
            [binary]="true"
            (onChange)="switchFacilityDifference()"
            [(ngModel)]="differentFacility">
          </p-checkbox>
          <label for="differentFacilityCheck" class="ml-2">Different Servicing Facility</label>
        </div>
      </div>
    }

    @if (!differentFacility) {
      @if (loading) {
        <p-progressSpinner></p-progressSpinner>
      }
      @if (!loading) {
        <ng-container
          *ngTemplateOutlet="facilitiesTemplate;
            context: {
              facilities: userFacilities,
              selectedFacilityIndex: selectedUserFacilityIndex,
              selectedFacilityPgpId: selectedUserFacilityPgpId
            }">
        </ng-container>
      }
    } @else {
      <provider-search [providerLabel]="'Servicing Facility'" (search)="onSearch($event)"></provider-search>
      @if (loading) {
        <p-progressSpinner></p-progressSpinner>
      }
      @if (!loading && npiSearchFacilities) {
        @if (npiSearchFacilities.length) {
          <ng-container
            *ngTemplateOutlet="facilitiesTemplate;
              context: {
                facilities: npiSearchFacilities,
                selectedFacilityIndex: selectedNpiFacilityIndex,
                selectedFacilityPgpId: selectedNpiFacilityPgpId
              }
          ">
        </ng-container>
      } @else {
        <servicing-facility-new
          [contactDetails]="contactDetails"
          [isExternalFlow]="isExternalFlow"
          [(newServicingFacility)]="newFacility"
          (newServicingFacilityChange)="onNewFacilityUpdated()"
        ></servicing-facility-new>
      }
    }
  }

</p-panel>

<div class="flex justify-between pt-6">
  <div>
    <button
      pButton
      severity="danger"
      aria-label="Cancel Create Authorization"
      label="Cancel"
      icon="pi pi-times"
      type="button"
      data-test-id="cancel-request-button"
      (click)="onCancel()"
    ></button>
  </div>
  <div>
    <button
      pButton
      aria-label="Back Step to Diagnosis"
      label="Back"
      icon="pi pi-arrow-left"
      class="p-button-secondary mr-2"
      type="button"
      data-test-id="back-step-button"
      (click)="onClickBack()"
    ></button>
    <button
      pButton
      aria-label="Next Step to Ordering Provider"
      label="Next"
      icon="pi pi-arrow-right"
      iconPos="right"
      type="button"
      data-test-id="next-step-button"
      [disabled]="!canSubmit"
      (click)="onSubmit()"
    ></button>
  </div>
</div>
</div>

<ng-template
  #facilitiesTemplate
  let-facilities="facilities"
  let-index="selectedFacilityIndex"
  >
  @if (index !== undefined) {
    <servicing-facility-info
      [contactDetails]="contactDetails"
      [isExternalFlow]="isExternalFlow"
      [servicingFacility]="facilities[index]"
      [tenantName]="tenantName"
      [isGoldCardVisible]="isGoldCardVisible"
      (detailsChanged)="onDetailsChanged($event)"
    ></servicing-facility-info>
  } @else {
    <servicing-facility-select
      [facilities]="facilities"
      [isExternal]="isExternalFlow"
      (selected)="onSelectedFacility($event, facilities)">
    </servicing-facility-select>
  }

</ng-template>

<p-confirmDialog
  [style]="{ width: '398px' }"
></p-confirmDialog>
